import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';

const PunchPointsModal = ({ show, onHide, value, onChange, onSave, canEdit }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Punch Points (Rework Comments)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {canEdit ? (
          <>
            <p className="text-muted mb-3">
              Please enter the points to be addressed before sending this form to re-work.
            </p>
            <ReactQuill
              theme="snow"
              value={value || ''}
              onChange={onChange}
              modules={modules}
              style={{ height: '300px', marginBottom: '50px' }}
            />
          </>
        ) : (
          <div>
            {value ? (
              <div
                className="quill-read-only-content"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            ) : (
              <p className="text-muted text-center">No punch points have been added yet.</p>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {canEdit ? 'Cancel' : 'Close'}
        </Button>
        {canEdit && (
          <Button variant="primary" onClick={onSave}>
             Submit to Rework
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

PunchPointsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default PunchPointsModal;
